import Content, { IContent } from "@/model/Content/Content"
import hasService, { IHasService } from "@/model/mixins/Service/hasService"


type SkiSchool = { [key: string]: any } // TODO define fields



class ServiceContentBase extends Content {
    private code?: string
    private nameCommercial?: string
    private fournisseurId?: string
    private fournisseurName?: string
    private family?: string
    private description?: string
    private name?: string
    private criterias: string[] = []
    private additionalInformation?: string
    private link?: string
    private skiSchool?: SkiSchool
    private image?: string
    private image_90deg?: string
    private remarques?: string
    private criteriasSet: Set<string> = new Set()

    constructor() { super() }


    setCode(code: string): void { this.code = code }
    setNameCommercial(nameCommercial: string): void { this.nameCommercial = nameCommercial }
    setFournisseurId(fournisseurId: string): void { this.fournisseurId = fournisseurId}
    setFournisseurName(fournisseurName: string): void { this.fournisseurName = fournisseurName }
    setFamily(family: string): void { this.family = family }
    setDescription(description: string): void { this.description = description }
    setName(name: string): void { this.name = name }
    setCriterias(criterias: string[]): void { 
        this.criterias = criterias
        this.criteriasSet = new Set(this.criterias)
    }
    setImage(image: string): void { this.image = image }
    setImage_90deg(image_90deg: string): void { this.image_90deg = image_90deg }
    setAdditionalInformation(additionalInformation: string): void { this.additionalInformation = additionalInformation }
    setLink(link: string): void { this.link = link }
    setSkiSchool(skiSchool: SkiSchool): void { this.skiSchool = skiSchool }

    getCode(): string | undefined { return this.code }
    getNameCommercial(): string | undefined { return this.nameCommercial }
    getFournisseurId(): string | undefined { return this.fournisseurId }
    getFournisseurName(): string | undefined { return this.fournisseurName }
    getFamily(): string | undefined { return this.family }
    getDescription(): string | undefined { return this.description }
    getName(): string | undefined { return this.name }
    getCriterias(): string[] { return this.criterias }
    getImage(): string | undefined { return this.image }
    getImage_90deg(): string | undefined { return this.image_90deg }
    getAdditionalInformation(): string | undefined { return this.additionalInformation }
    getLink(): string | undefined { return this.link }
    getSkiSchool(): SkiSchool | undefined { return this.skiSchool }
    getRemarks(): string | undefined {return this.remarques}
    getCriteriasSet(): Set<string> { return this.criteriasSet }



}

export interface IServiceContent extends ServiceContentBase, IContent, IHasService {
    getCode(): string | undefined
    getNameCommercial(): string | undefined
    getFournisseurId(): string | undefined
    getFournisseurName(): string | undefined
    getFamily(): string | undefined
    getDescription(): string | undefined
    getName(): string | undefined
    getCriterias(): string[]
    getImage(): string | undefined
    getImage_90deg(): string | undefined
    getAdditionalInformation(): string | undefined
    getLink(): string | undefined
    getSkiSchool(): SkiSchool | undefined
    getRemarks(): string | undefined
    getCriteriasSet(): Set<string>
}


const ServiceContent: Constructor<IServiceContent> = hasService(ServiceContentBase)
export default ServiceContent